import { render, staticRenderFns } from "./CursoInformacion.vue?vue&type=template&id=64663a61&"
import script from "./CursoInformacion.vue?vue&type=script&lang=js&"
export * from "./CursoInformacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports